import BasicInformation from "./tabs/BasicInformation";
import React, { useEffect, useRef, useState } from "react";
import { Tabs, Tab, Tooltip } from "@mui/material";
import { data, useLocation } from "react-router-dom";

import axios from "axios";
import { Category, Inventory } from "@mui/icons-material";
import InventoryStructureDetails from "./tabs/InventoryStructureDetails";
import SpecoficationBarcode from "./tabs/SpecificationBarcode";
import PackagingExport from "./tabs/PackagingExport";
import BillofMaterials from "./tabs/BillofMaterials";

import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@mui/material";

import {
  FaInfoCircle,
  FaBoxes,
  FaClipboardList,
  FaTruckLoading,
  FaBarcode,
} from "react-icons/fa";
import canUserSeeThis from "../common/CheckCanUserSeeThis";
import ProductListing from "../salesInvoice/ProductsModal";
import Modal from "../common/CommonModal";
import checkIfUserHasAccess from "../common/UserCheckAccess";

const ItemCreation = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const location = useLocation();

  const [makeInactive, setMakeInactive] = useState(false);
  const [onlineMarketplace, setOnlineMarketplace] = useState(false);
  const [blockFromOrder, setBlockFromOrder] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [multiUnitsEntries, setMultiUnitsEntries] = useState([]);
  const [bomEntries, setBomEntries] = useState([]);
  const [locationStockEntries, setLocationStockEntries] = useState([]);
  const [equivalentEntries, setEquivalentEntries] = useState([]);
  const [saveEquivalentEntries, setSaveEquivalentEntries] = useState([]);
  const [saveEquivalentMode, setSaveEquivalentMode] = useState([]);
  const [alternateEntries, setAlternateEntries] = useState([]);
  const [showCodeModal, setShowCodeModal] = useState(false);
  const [duplicateCode, setDuplicateCode] = useState("");
  const [fetchImageAllow, setFetchImageAllow] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [partTableData, setPartTableData] = useState([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalSuggestions, setModalSuggestions] = useState([]);
  const [searchBy, setSearchBy] = useState("UNIVERSAL");
  const [modalPageNumber, setModalPageNumber] = useState(1);
  const [modalPageSize] = useState(500);
  const [modalTotalRows, setModalTotalRows] = useState(0);
  const [modalSearchQuery, setModalSearchQuery] = useState("-");
  const [loadingModalData, setLoadingModalData] = useState(false);
  const departmentLocation = localStorage.getItem("departmentLocation") || "A";

  const BOMRef = useRef();
  // console.log("Received Item Code:", itemCode);

  const handleResetTest = () => {
    BOMRef.current.resetBOM();
  };

  const CustomTab = ({ label, icon, ...props }) => {
    return (
      <Tab
        label={
          <span className="flex items-center space-x-2">
            <span className="text-lg transition-transform duration-200 group-hover:scale-110 group-[.Mui-selected]:scale-110 group-[.Mui-selected]:text-white">
              {icon}
            </span>
            <span className="font-semibold ">{label}</span>
          </span>
        }
        className={`mb-4 group relative text-sm font-medium 
               transition-all duration-300 ease-in-out
               hover:text-blue-500 hover:bg-blue-50 hover:shadow-sm hover:scale-90 hover:rounded-md
               [&.Mui-selected]:text-blue-800 
               [&.Mui-selected]:bg-blue-100
               [&.Mui-selected]:border-b-4 [&.Mui-selected]:border-blue-500
               [&.Mui-selected]:shadow-md
               [&.Mui-selected]:rounded-md
               focus:outline-none focus:ring-0 focus:ring-none focus:ring-opacity-0 
               px-4 py-3 rounded-t-lg
               min-w-[120px] md:min-w-[150px] 
               `}
        sx={{
          "&:focus": {
            zIndex: 10,
          },
        }}
        aria-label={label}
        {...props}
      />
    );
  };

  useEffect(() => {
    const tabIndexFromChild = location.state?.tabIndex;

    if (typeof tabIndexFromChild === "number") {
      setTabIndex(tabIndexFromChild);
    } else {
      setTabIndex(0); // default when not from supplier creation
    }

    window.history.replaceState({}, document.title);

    const itemCodeFromStockList = location.state;

    handleEditExistingItem(itemCodeFromStockList);
  }, [location.state]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const itemFromRequest = location?.state?.requestData;
  console.log("Item from request:", itemFromRequest);

  const initialFormData = {
    code: "",
    oem: "",
    description: itemFromRequest?.description || "",
    baseUnit: "",
    group: "",
    subGroup: "",
    category: "",
    subCategory: "",
    hsCode: "",
    baseBin: "",
    origin: "",
    openingQty: "0",
    minQty: "0",
    retailPrice: "0",
    ocPcsBox: "0",
    resellerPrice: "0",
    openingCost: "0",
    dcp: "0",
    weight: "0",
    blockPrice: "0",
    volume: "0",
    modelNo: "",
    classType: "",
    desc1: "",
    // OC (Outer Carton)
    ocGrossWeight: "",
    ocNetWeight: "",
    ocCartonSize: "",
    ocPcsBox: "",
    ocLength: "",
    ocBreadth: "",
    ocHeight: "",
    ocCbm: "",
    // IC (Inner Carton)
    icWeight: "",
    icCartonSize: "",
    icQtyBox: "",
    icLength: "",
    icBreadth: "",
    icHeight: "",
    icCbm: "",

    theme: "",
    name1: "",
    name2: "",
    name3: "",
    name4: "",
    name5: "",

    bomEntries: [],
    locationStockEntries: [],
  };

  const [formData, setFormData] = useState(initialFormData);
  const [selectedItemType, setSelectedItemType] = useState("inventory");

  const handleTypeChange = (event) => {
    setSelectedItemType(event.target.value);
  };

  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";
  let currentUserName_from_local_storage = localStorage.getItem(
    "currentUserName",
  )
    ? localStorage.getItem("currentUserName")
    : "-";

  const buildMultiUnitsPayload = () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";
    return multiUnitsEntries.map((row) => ({
      CmpCode: company_code_from_local_storage,
      mode: "ENTRY",
      CODE: formData.code,
      UNIT: row.unit || "",
      FRAC: Number(row.partNumber) || 0,
      PRICE: Number(row.quantity) || 0,
      bu: "A",
      BARCODE: "",
    }));
  };

  const itemCreationPayload = [
    {
      cmpcode: company_code_from_local_storage,
      mode: isEdit ? "EDIT" : "ENTRY",
      code: formData.code || "",
      unit: formData.baseUnit || "",
      group: formData.group || "",
      sgroup: formData.subGroup || "",
      categ: formData.category || "",
      scateg: formData.subCategory || "",
      class: formData.hsCode || "",
      desc: formData.description || "",
      location: formData.baseBin || "",
      store_no: formData.origin || "0",
      qty_open: formData.openingQty || "0", //
      rcvd_ytd: "0",
      issd_ytd: "0",
      qty_rorder: formData.minQty || "0", //
      cost_unit: "0",
      cost_avg: "0",
      price_unit: formData.retailPrice || "0",
      packing: formData.ocPcsBox || "0",
      discount: "0",
      reserveqty: "0",
      po_qty: "0",
      batch: formData.oem || "",
      rcvd01: "0",
      issd01: "0",
      rcvd02: "0",
      issd02: "0",
      rcvd03: "0",
      issd03: "0",
      rcvd04: "0",
      issd04: "0",
      rcvd05: "0",
      issd05: "0",
      rcvd06: "0",
      issd06: "0",
      rcvd07: "0",
      issd07: "0",
      rcvd08: "0",
      issd08: "0",
      rcvd09: "0",
      issd09: "0",
      rcvd10: "0",
      issd10: "0",
      rcvd11: "0",
      issd11: "0",
      rcvd12: "0",
      issd12: "0",
      price2: formData.resellerPrice || "0",
      min_qty: "0",
      max_qty: "0",
      do_pending: "0",
      cost_open: formData.openingCost || "0", //
      packprice1: "0",
      fraction: "1",
      qty2_open: "0",
      qty2: "0",
      perishable: "",
      cost_fifo: formData.dcp || "0",
      weight: formData.weight || "0", //
      surf_cost: "0",
      supplier: "",
      dac: selectedItemType === "service" ? "1" : "0",
      deptno: "",
      packcost: "0",
      phy_qty: "0",
      phy_date: "",
      price3:
        formData.dcp > 0
          ? String(formData.dcp)
          : String(formData.blockPrice) || "0", // block price
      fraction2: "1",
      qtyf_open: "0",
      locaphy: "0",
      locbphy: "0",
      loccphy: "0",
      locdphy: "0",
      locephy: "0",
      locfphy: "0",
      locgphy: "0",
      exp_date: null,
      bonus: "0",
      priced: formData.exportPrice || "0", // export price
      pricee: "0",
      pricef: "0",
      priceg: "0",
      priceh: "0",
      pricei: "0",
      pricej: "0",
      gweight: formData.volume + "" || "0", //
      nweight: formData.weight + "" || "0", //
      measment: isEdit ? currentUserName_from_local_storage : "",
      upd: "",
      lochphy: "0",
      blkitem: "",
      modelno1: formData.modelNo || "0",
      modelno2: "",
      modelno3: formData.classType || "",
      LPCOST: "0",
      LSPRICE: "0",
      desc1: formData.desc1 || "",
      desc2: formData.flashCommentType || "", // flash comment type
      active: makeInactive ? "A" : "0", // make inactive A
      VOLACTIVE: onlineMarketplace ? "A" : "0", // online market place
      SPRICETYPE: blockFromOrder ? "A" : "0", // Block from Order
      SP: "0",
      priceK: "0",
      priceL: "0",
      priceM: "0",
      priceN: "0",
      priceO: "0",
      priceP: "0",
      priceQ: "0",
      priceR: "0",
      priceS: "0",
      priceT: "0",
      priceU: "0",
      priceV: "0",
      priceW: "0",
      priceX: "0",
      priceY: "0",
      GrossWeight_OC: formData.ocGrossWeight || "",
      NetWeight_OC: formData.ocNetWeight || "",
      CartonSize_OC: formData.ocCartonSize || "",
      PcsBox_OC: formData.ocPcsBox || "",
      Length_OC: formData.ocLength || "",
      Breadth_OC: formData.ocBreadth || "",
      Height_OC: formData.ocHeight || "",
      CBM_Master_OC: formData.ocCbm || "",
      Weight_IC: formData.icWeight || "",
      CartonSize_IC: formData.icCartonSize || "",
      Qty_InnerBox_IC: formData.icQtyBox || "",
      Length_IC: formData.icLength || "",
      Breadth_IC: formData.icBreadth || "",
      Height_IC: formData.icHeight || "",
      CBM_InnerBox_IC: formData.icCbm || "",
    },
  ];

  useEffect(() => {
    if (formData.code && formData.code.length > 0) {
      fetchLocationStock();
    }
  }, [isEdit]);

  const fetchLocationStock = async () => {
    try {
      const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      const companyCode = localStorage.getItem("companyCode");

      const url = `${apiPaths[0]?.API_CONFIG}/api/CRMItemLocation/${companyCode}/${formData.code}`;

      const response = await axios.get(url);
      console.log("location stock response.data :", response.data);
      const data = response.data;
      setFormData((prev) => ({
        ...prev,
        locationStockEntries: data,
      }));
    } catch (err) {
      console.error("Error fetching location stock:", err);
    }
  };

  useEffect(() => {
    const entries = formData?.bomEntries || [];

    const hasEntries = entries.filter((r) => r.c_code?.trim() !== "");

    const hasEmptyQty = hasEntries.some(
      (r) =>
        r.Qty === "" ||
        r.Qty === null ||
        r.Qty === undefined ||
        Number(r.Qty) <= 0,
    );
    console.log("hasEmptyQty:", hasEmptyQty);

    if (hasEntries.length > 0 && hasEmptyQty) {
      setIsSaveDisabled(true);
    } else {
      setIsSaveDisabled(false);
    }
  }, [formData?.bomEntries]);

  console.log("isSaveDisabled:", isSaveDisabled);

  // const save = async () => {
  //   console.log("Saved From Parent ", formData);
  //   let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
  //     ? JSON.parse(localStorage.getItem("apiPaths"))
  //     : "-";

  //   const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
  //   const apiURL = `${apiBaseURL}/api/productregCRM`;

  //   try {
  //     const response = await axios.post(apiURL, itemCreationPayload, {
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     console.log("itemCreationPayload saved Response:", response.data);

  //     setSnackbarMessage(
  //       isEdit ? "Item updated successfully!" : "Item saved successfully!"
  //     );
  //     setSnackbarSeverity("success");
  //     setSnackbarOpen(true);

  //     const moreUnitsPayload = buildMultiUnitsPayload();

  //     if (moreUnitsPayload.length > 0) {
  //       const apiMultiURL = `${apiBaseURL}/api/CRMMoreUnitsReg`;
  //       try {
  //         const unitsResponse = await axios.post(
  //           apiMultiURL,
  //           moreUnitsPayload,
  //           {
  //             headers: { "Content-Type": "application/json" },
  //           }
  //         );

  //         console.log("MULTI UNITS SAVED:", unitsResponse.data);
  //       } catch (error) {
  //         console.error("MULTI UNITS Saving API Error:", error);

  //         setSnackbarMessage("Failed to save MULTI UNITS. Try again.");
  //         setSnackbarSeverity("error");
  //         setSnackbarOpen(true);
  //       }
  //     }
  //     await saveGenequiPartTable();
  //     await saveAlternatePartTable();
  //     await saveBOMFromItemCreation();
  //     await saveLocationStockFromItemCreation();
  //   } catch (error) {
  //     console.error("API Error:", error);

  //     setSnackbarMessage("Failed to save item. Try again.");
  //     setSnackbarSeverity("error");
  //     setSnackbarOpen(true);
  //   }
  // };

  const save = async () => {
    console.log("Saving item...", formData);

    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    const apiBaseURL = apiPaths[0]?.API_CONFIG;

    try {
      // 1️⃣ SAVE MAIN ITEM FIRST
      const mainResponse = await axios.post(
        `${apiBaseURL}/api/productregCRM`,
        itemCreationPayload,
      );

      console.log("Main item saved:", mainResponse.data);

      // 2️⃣ NOW SAVE CHILDREN IN ORDER — EACH ONE VERIFIED
      const moreUnitsPayload = buildMultiUnitsPayload();
      // ITEM REQUEST
      if (itemFromRequest) {
        await saveItemRequest();
      }
      // MULTI UNITS
      if (moreUnitsPayload.length > 0) {
        try {
          await axios.post(
            `${apiBaseURL}/api/CRMMoreUnitsReg`,
            moreUnitsPayload,
          );
        } catch (err) {
          return showError("Saving Multi Units failed!");
        }
      }

      // GENERAL EQUIVALENT
      try {
        await saveGenequiPartTable();
      } catch (err) {
        return showError("Saving Equivalent Parts failed!");
      }

      // ALTERNATE PARTS
      try {
        await saveAlternatePartTable();
      } catch (err) {
        return showError("Saving Alternate Parts failed!");
      }

      // BOM
      try {
        await saveBOMFromItemCreation();
      } catch (err) {
        return showError("Saving BOM failed!");
      }

      // LOCATION STOCK
      try {
        await saveLocationStockFromItemCreation();
      } catch (err) {
        console.error("Error while saving location stock!", err);
        return showError("Saving Location Stock failed!");
      }

      // 3️⃣ ONLY NOW SHOW SUCCESS
      showSuccess(
        isEdit ? "Item updated successfully!" : "Item saved successfully!",
      );
      if (itemFromRequest) {
        // navigate
      }
      setTimeout(() => {
        setFormData(initialFormData);
      }, 500);
    } catch (error) {
      console.error("Main Save Error:", error);
      showError("Failed to save main item.");
    }
  };

  const saveItemRequest = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";
    const mainCode = formData.code;

    const payload = [
      {
        cmpcode: company_code_from_local_storage,
        mode: "UPDATE",
        code: itemFromRequest?.code || "",
        description: itemFromRequest?.description || "",
        unit: itemFromRequest?.unit || "",
        soUid: itemFromRequest?.soUid || "",
        maincode: mainCode || "",
        status: "CREATED",
        req_date: itemFromRequest?.req_date || "",
        Req_User: itemFromRequest?.Req_User || "",
      },
    ];

    console.log("item request Payload!:", payload);
    try {
      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
      const apiURL = `${apiBaseURL}/api/CRMItemCreationRequest`;
      const response = await axios.post(apiURL, payload, {
        headers: { "Content-Type": "application/json" },
      });
      const data = response.data;
      console.log("item request Saved!:", data);
    } catch (error) {
      console.error("Error while saving item request !", error);
    }
  };

  // SMALL HELPERS
  const showError = (msg) => {
    setSnackbarMessage(msg);
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  };

  const showSuccess = (msg) => {
    setSnackbarMessage(msg);
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
  };

  const handleSaveEquivalent = async (entries) => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";
    const payload = entries.map((entry) => ({
      CmpCode: company_code_from_local_storage,
      mode: "ADD",
      code: "ITEM001",
      s_code: entry.partNumber,
      s_description: entry.oemBrand,
      supplier: "",
      type: "",
    }));

    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    const apiBaseURL = apiPaths[0]?.API_CONFIG;

    const apiURL = `${apiBaseURL}/api/CRMSubstitutes`;

    const res = await axios.post(apiURL, payload, {
      headers: { "Content-Type": "application/json" },
    });

    console.log("Saved from parent:", res.data);
  };

  const saveEquivalentPartTable = (entries, mode) => {
    console.log("Entries:", entries);
    console.log("Mode:", mode);
    setSaveEquivalentEntries(entries);
    setSaveEquivalentMode(mode);
    // parent handles API call, validation, toast/snackbar etc.
  };

  const clear = () => {
    setFormData(initialFormData);
    console.log("CLEARED : ", formData);
  };

  const handleChange = (field, value) => {
    if (field === "code") {
      if (formData.code.length > 0) {
        codeDupCheck(value);
      }
    }
    setFormData({ ...formData, [field]: value });
  };

  const codeDupCheck = async (value) => {
    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";
      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
      const response = await axios.get(
        `${apiBaseURL}/api/DupCheck/${company_code_from_local_storage}/CODE/${encodeURIComponent(value)}`,
      );
      const data = response.data[0];
      if (data.COUNT != 0) {
        // alert("This code already exists! please select Different code!");
        setDuplicateCode(value);
        setShowCodeModal(true);
      }
      return;
    } catch (error) {
      console.error("Error While Checking Duplicate Code!");
    }
  };

  const handleCreateNewItem = async () => {
    setShowCodeModal(false);
    try {
      let company_code = localStorage.getItem("companyCode") || "-";
      let apiPaths = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";
      const apiBaseURL = apiPaths[0]?.API_CONFIG;
      const encodedItemCode = encodeURIComponent(duplicateCode);
      const targetURL = `${apiBaseURL}/api/CpaysCount/${company_code}/ITEMDETAIL/${encodedItemCode}/-`;
      const res = await axios.get(targetURL);
      const item = res.data[0];

      setFormData({
        ...initialFormData,
        code: item.code || "",
        description: item.desc || "",
      });
      setSelectedItemType(item.dac === true ? "service" : "inventory");
      setIsEdit(false);
      setMakeInactive(false);
      setOnlineMarketplace(false);
      setBlockFromOrder(false);
    } catch (error) {
      console.error("Error fetching item details:", error);
    }
  };

  const fetchModalTotalCount = async (
    query = "-",
    searchByValue = searchBy,
  ) => {
    try {
      let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      const BASE_URL = apiPaths[0]?.API_CONFIG;
      const COMPANY_CODE = localStorage.getItem("companyCode");
      const effectiveQuery = query?.trim() === "" ? "-" : query?.trim() || "-";
      const formattedQuery = effectiveQuery.replace(/\//g, "%2F");
      const url = `${BASE_URL}/api/cpayscount/${COMPANY_CODE}/ITEMCOUNT/${searchByValue}/${formattedQuery}`;
      const response = await axios.get(url);
      if (Array.isArray(response.data) && response.data[0]?.CNT) {
        setModalTotalRows(Number(response.data[0].CNT));
      } else {
        setModalTotalRows(0);
      }
    } catch (err) {
      console.error("Failed to fetch total count", err);
      setModalTotalRows(0);
    }
  };

  const fetchProductDataForModal = async (
    query = "-",
    searchByValue = searchBy,
    location = departmentLocation,
    page = modalPageNumber,
    limit = modalPageSize,
  ) => {
    try {
      setLoadingModalData(true);
      let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      const BASE_URL = apiPaths[0]?.API_CONFIG;
      const COMPANY_CODE = localStorage.getItem("companyCode");

      const effectiveQuery = query?.trim() === "" ? "-" : query?.trim() || "-";
      const formattedQuery = effectiveQuery.replace(/\//g, "%2F");

      const url = `${BASE_URL}/api/CRMStockListPage/${COMPANY_CODE}/${searchByValue}/${formattedQuery}/${departmentLocation}/-/${page}/${limit}`;
      const response = await axios.get(url);
      if (response.data) {
        setModalSuggestions(response.data);
      } else {
        setModalSuggestions([]);
      }
    } catch (err) {
      console.error("Failed to fetch product data", err);
      setModalSuggestions([]);
    } finally {
      setLoadingModalData(false);
    }
  };

  const handleModalSearchQueryChange = async (query = "-") => {
    setModalSearchQuery(query);
    setModalPageNumber(1);
    await fetchProductDataForModal(
      query,
      searchBy,
      departmentLocation,
      1,
      modalPageSize,
    );
    await fetchModalTotalCount(query, searchBy);
  };

  useEffect(() => {
    if (isModalOpen) {
      fetchProductDataForModal(
        modalSearchQuery,
        searchBy,
        departmentLocation,
        modalPageNumber,
        modalPageSize,
      );
    }
  }, [modalPageNumber, modalPageSize, isModalOpen, searchBy]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.defaultPrevented) return;
      // Check if not in a particular input field where F2 might mean something else, though F2 is usually free
      if (e.key === "F2" && !isModalOpen) {
        e.preventDefault();
        setModalSearchQuery("-");
        setModalPageNumber(1);
        fetchProductDataForModal(
          "-",
          searchBy,
          departmentLocation,
          1,
          modalPageSize,
        );
        fetchModalTotalCount("-", searchBy);
        setIsModalOpen(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen, searchBy, modalPageSize, modalPageNumber]);

  const handleProductSelectFromModal = (product) => {
    console.log("Product selected from modal:", product);
    setIsModalOpen(false);
    setDuplicateCode(product.Code || "");
    setShowCodeModal(true);
  };

  const handleEditExistingItem = async (editItemCode) => {
    console.log(editItemCode, "editItemCode");
    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";
      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

      const encodedItemCode = encodeURIComponent(editItemCode);
      console.log("encodedItemCode", encodedItemCode)

      const targetURL = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/ITEMDETAIL/${encodedItemCode}/-`;

      console.log("check", targetURL);

      const res = await axios.get(targetURL);

      // Load the item details into form
      console.log("Item Data retrived", res.data[0]);
      const item = res.data[0];

      const mappedData = {
        code: item.code || "",
        oem: item.batch || "",
        description: item.desc || "",
        modelNo: item.modelno1 || "",

        makeInactive: item.active === "A",
        onlineMarketplace: item.VOLACTIVE === "A",
        blockFromOrder: item.SPRICETYPE === "A",
        // brandClass
        // EAN
        // PartGroup
        // VehicleFamily yet to connect
        group: item.group || "",
        subGroup: item.sgroup || "",
        category: item.categ || "",
        subCategory: item.scateg || "",
        openingQty: item.qty_open || "",
        openingCost: item.cost_open || "",
        baseUnit: item.unit || "",
        baseBin: item.location || "",
        minQty: item.qty_rorder || "",

        classType: item.modelno3 || "",

        volume: item.gweight || "0",
        weight: item.weight || "0",
        hsCode: item.class || "0",
        origin: item.store_no || "",
        flashCommentType: item.desc2 || "",

        retailPrice: item.price_unit || "0",

        resellerPrice: item.price2 || "0",

        exportPrice: item.priced || "0",
        blockPrice: item.cost_fifo > 0 ? item.cost_fifo : item.price3 || "0",

        dcp: item.cost_fifo || "0",
        lpCost: item.LPCOST || "0",
        costAvg: item.cost_avg || "0",
        balanceQty: Number(item.rcvd_ytd - item.issd_ytd) || "0",

        // packaging & Export details
        ocGrossWeight: item.GrossWeight_OC || "0",
        ocNetWeight: item.NetWeight_OC || "0",
        ocCartonSize: item.CartonSize_OC || "0",
        ocPcsBox: item.PcsBox_OC || "0",
        ocLength: item.Length_OC || "0",
        ocBreadth: item.Breadth_OC || "0",
        ocHeight: item.Height_OC || "0",
        ocCbm: item.CBM_Master_OC || "0",
        // inner
        icWeight: item.Weight_IC || "0",
        icCartonSize: item.CartonSize_IC || "0",
        icQtyBox: item.Qty_InnerBox_IC || "0",
        icLength: item.Length_IC || "0",
        icBreadth: item.Breadth_IC || "0",
        icHeight: item.Height_IC || "0",
        icCbm: item.CBM_InnerBox_IC || "0",
        // barcode
        desc1: item.desc1 || "",
      };
      console.log("Mapped Data:", mappedData);
      setMakeInactive(mappedData.makeInactive);
      setOnlineMarketplace(mappedData.onlineMarketplace);
      setBlockFromOrder(mappedData.blockFromOrder);
      setFormData(mappedData);
      setSelectedItemType(item.dac === true ? "service" : "inventory");
      setIsEdit(true);
    } catch (error) {
      console.error("Error loading item details");
    }
    setFetchImageAllow(true);
    setShowCodeModal(false);
  };

  useEffect(() => {
    if (bomEntries.length > 1) {
      console.log("bomEntries in ItemCreation:", bomEntries);
    }
  }, [bomEntries]);

  useEffect(() => {
    if (formData.locationStockEntries?.length > 1) {
      console.log(
        "formData.locationStockEntries in ItemCreation:",
        formData.locationStockEntries,
      );
    }
  }, [formData.locationStockEntries]);

  const saveBOMFromItemCreation = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths"));
    let apiBaseURL = apiPaths[0]?.API_CONFIG;
    const CmpCode = localStorage.getItem("companyCode");
    const parentCode = formData.code;

    let payload = formData?.bomEntries
      .filter((r) => r.c_code?.trim() !== "")
      .map((r) => ({
        CmpCode: CmpCode,
        mode: "ENTRY",
        code: parentCode,
        c_code: r.c_code,
        c_description: r.c_description,
        unit: r.unit,
        qty: r.Qty,
      }));

    if (payload.length === 0) {
      payload = [
        {
          CmpCode: CmpCode,
          mode: "ENTRY",
          code: parentCode,
          c_code: "",
          c_description: "",
          unit: "",
          qty: 0,
        },
      ];
    }

    await axios.post(`${apiBaseURL}/api/CRMBOM`, payload);
    BOMRef.current.resetBOM(); //grandChild Ref
  };

  // const saveLocationStockFromItemCreation = async () => {
  //   let apiPaths = JSON.parse(localStorage.getItem("apiPaths"));
  //   let apiBaseURL = apiPaths[0]?.API_CONFIG;
  //   const CmpCode = localStorage.getItem("companyCode");
  //   const parentCode = formData.code;

  //   console.log(
  //     "formData?.locationStockEntries:",
  //     formData?.locationStockEntries,
  //   );
  //   const payload = formData.locationStockEntries
  //     ?.filter((r) => r.c_code?.trim() !== "")
  //     .map((r) => ({
  //       CMPCODE: CmpCode,
  //       CODE: parentCode,
  //       LCODE: r.LCODE,
  //       OPEN_QTY: r.OPEN_QTY,
  //       BIN_LOC: r.BIN_LOC,
  //       MINQTY: r.MINQTY,

  //       // CMPCODE: "DOODDEMO",
  //       // CODE: "10004525812MRAL7035",
  //       // LCODE: "A",
  //       // OPEN_QTY: 5,
  //       // BIN_LOC: "ABCC2",
  //       // MINQTY: 3,
  //     }));

  //   if (payload.length === 0) return; // skip

  //   console.log("Payload of location Stock:", payload);

  //   await axios.post(`${apiBaseURL}/api/CRMItemLocationStockReg`, payload);
  // };

  const saveLocationStockFromItemCreation = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths"));
    let apiBaseURL = apiPaths[0]?.API_CONFIG;
    const CmpCode = localStorage.getItem("companyCode");
    const parentCode = formData.code;

    console.log(
      "formData?.locationStockEntries:",
      formData?.locationStockEntries,
    );

    // ✅ guard against undefined/null
    const entries = formData?.locationStockEntries || [];

    const payload = entries
      .filter((r) => r.LCODE?.trim() !== "") // ✅ filter by actual field name
      .map((r) => ({
        CMPCODE: CmpCode,
        CODE: parentCode,
        LCODE: r.LCODE || "",
        OPEN_QTY: r.OPEN_QTY || 0,
        BIN_LOC: r.BIN_LOC || "",
        MINQTY: r.MINQTY || 0,
      }));

    if (payload.length === 0) {
      console.log("No location stock entries to save, skipping.");
      return; // ✅ skip silently, don't throw
    }

    console.log("Payload of location Stock:", payload);

    await axios.post(`${apiBaseURL}/api/CRMItemLocationStockReg`, payload);
  };

  const handlePartTableEntriesChange = (mode, entries) => {
    setPartTableData((prev) => ({
      ...prev,
      [mode]: entries, // store entries per mode
    }));
  };

  useEffect(() => {
    console.log("PartTableData:", partTableData);
    // saveGenequiPartTable()
    // saveAlternatePartTable()
  }, [partTableData]);

  const saveGenequiPartTable = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    const genequidata = partTableData["GENEQUI"];
    console.log("genequidata:", genequidata);

    if (!Array.isArray(genequidata) || genequidata.length === 0) {
      console.log("No genequidata to save. Skipping API call.");
      return;
    }

    const mainCode = formData.code;
    const mode = "GENEQUI";

    const payload = genequidata?.map((entry) => ({
      CmpCode: company_code_from_local_storage,
      mode: mode,
      code: mainCode || "",
      s_code: entry.partNumber || "",
      s_description: entry.oemBrand || "",
      supplier: "",
      type: "",
    }));

    try {
      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
      const apiURL = `${apiBaseURL}/api/CRMSubstitutes`;
      const response = await axios.post(apiURL, payload, {
        headers: { "Content-Type": "application/json" },
      });
      const data = response.data;
      console.log("Genuine Equivalents Saved!:", data);
    } catch (error) {
      console.error("Error whiloe saving Genuine!", error);
    }
  };

  const saveAlternatePartTable = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    const alternatedata = partTableData["ALTERNATE"];
    console.log("alternatedata:", alternatedata);

    if (!Array.isArray(alternatedata) || alternatedata.length === 0) {
      console.log("No alternatedata to save. Skipping API call.");
      return;
    }

    const mainCode = formData.code;
    const mode = "ALTERNATE";

    const payload = alternatedata?.map((entry) => ({
      CmpCode: company_code_from_local_storage,
      mode: mode,
      code: mainCode || "",
      s_code: entry.partNumber || "",
      s_description: entry.oemBrand || "",
      supplier: "",
      type: "",
    }));

    try {
      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
      const apiURL = `${apiBaseURL}/api/CRMSubstitutes`;
      const response = await axios.post(apiURL, payload, {
        headers: { "Content-Type": "application/json" },
      });
      const data = response.data;
      console.log("alternatedata Saved!:", data);
    } catch (error) {
      console.error("Error whiloe saving alternatedata!", error);
    }
  };

  return (
    <div className="mx-4">
      <div className="flex justify-left items-center gap-8">
        <h2 className="text-xl text-gray-800 ">Item Creation Dashboard</h2>

        <div>
          {/* <label className="block text-xs text-gray-600  my-2  ">
                Retail Price
              </label>
              <input
                value={formData.retailPrice || ""}
                // onChange={(e) => handleChange("retailPrice", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Retail Price"
              /> */}
          <FormControl>
            {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={selectedItemType}
              onChange={handleTypeChange}
            >
              <FormControlLabel
                value="inventory"
                control={
                  <Radio
                    sx={{
                      color: "#BD1528",
                      "&.Mui-checked": {
                        color: "#BD1528",
                      },
                    }}
                  />
                }
                label={`Inventory`}
              />
              {checkIfUserHasAccess("WP") && (
                <FormControlLabel
                  value="service"
                  control={
                    <Radio
                      sx={{
                        color: "#BD1528",
                        "&.Mui-checked": {
                          color: "#BD1528",
                        },
                      }}
                    />
                  }
                  label={`Service`}
                />
              )}
            </RadioGroup>
          </FormControl>
        </div>
      </div>

      <div>
        <div className="grid grid-cols-3 gap-8 space-y-2">
          <div className=" ">
            <div>
              <label className="block text-xs text-gray-600  my-2  ">
                Code <span className="text-red-500">*</span>
              </label>
              {/* <input
                // disabled={isEdit}
                value={formData.code || ""}
                onChange={(e) => handleChange("code", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Code"
              /> */}

              <input
                value={formData.code || ""}
                onChange={(e) => {
                  // Only update the visual value while typing (no API call)
                  setFormData({ ...formData, code: e.target.value });
                }}
                onBlur={(e) => {
                  // This runs when user clicks away or tabs out
                  const value = e.target.value.trim();
                  // if (value && value !== formData.code) {
                  //   // Only trigger duplicate check if value actually changed
                  //   handleChange("code", value);
                  // }
                  handleChange("code", value);
                }}
                className={`placeholder-gray-400 w-full px-3 py-2 text-sm rounded border bg-gray-100 border-gray-200 
                `}
                placeholder="Code"
              />
            </div>

            <div>
              <label className="block text-xs text-gray-600  my-2  ">OEM</label>
              <input
                value={formData.oem || ""}
                onChange={(e) => handleChange("oem", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="OEM #"
              />
            </div>

            {/* <div className="col-span-2  my-2">
              <label className=" text-xs text-gray-600  my-2  ">
                Description
              </label>
              <input
                value={formData.description || ""}
                onChange={(e) => handleChange("description", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Description"
              />
            </div> */}
          </div>

          <div className="">
            {/* <div className="invisible">
              <label className=" block text-xs text-gray-600  my-2  ">
                Reseller Price
              </label>
              <input
                value={formData.resellerPrice || ""}
                // onChange={(e) => handleChange("resellerPrice", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Reseller Price"
              />
            </div> */}

            <div className="col-span-2 my-2">
              <label className="text-xs text-gray-600 my-2">
                Description
              </label>

              <textarea
                value={formData.description || ""}
                onChange={(e) => handleChange("description", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200 resize-none"
                placeholder="Description"
                rows={2}
              />
            </div>

            <div>
              <label className="block text-xs text-gray-600  my-2  ">
                Model No
              </label>
              <input
                value={formData.modelNo || ""}
                onChange={(e) => handleChange("modelNo", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Model No"
              />
            </div>
            {/* <div className="invisible">
              <label className="block text-xs text-gray-600  my-2  ">
                Brand Class
              </label>
              <input
                value={formData.brandClass || ""}
                onChange={(e) => handleChange("brandClass", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Brand Class"
              />
            </div> */}
          </div>

          <div className="w-full">
            <div className="flex flex-col  justify-left items-left mb-4">
              <div className="flex justify-center items-left gap-12 my-4">
                {/* <label className="text-sm  mr-2">Make Inactive</label> */}
                <label className="block text-sm text-gray-600   ">
                  Make Inactive
                </label>

                <input
                  type="checkbox"
                  className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                  checked={makeInactive}
                  onChange={(e) => setMakeInactive(e.target.checked)}
                />
              </div>
              <div className="flex justify-center items-left gap-3 my-3">
                <label className="block text-sm text-gray-600   ">
                  Online Market place
                </label>

                <input
                  type="checkbox"
                  className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                  checked={onlineMarketplace}
                  onChange={(e) => setOnlineMarketplace(e.target.checked)}
                />
              </div>
              <div className="flex justify-center items-left gap-8 my-3">
                <label className="block text-sm text-gray-600    ">
                  Block from Order
                </label>

                <input
                  type="checkbox"
                  className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                  checked={blockFromOrder}
                  onChange={(e) => setBlockFromOrder(e.target.checked)}
                />
              </div>
            </div>
          </div>
          {/* <div className="invisible">
            <div className="mt-10">
              <label className="block text-xs text-gray-600  my-2  ">
                EAN | UPC
              </label>
              <input
                value={formData.upc || ""}
                onChange={(e) => handleChange("upc", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="EAN | UPC"
              />
            </div>

            <div>
              <label className="block text-xs text-gray-600  my-2  ">
                Part Group
              </label>
              <input
                value={formData.partGroup || ""}
                onChange={(e) => handleChange("partGroup", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Part Group"
              />
            </div>
            <div>
              <label className="block text-xs text-gray-600  my-2  ">
                Vehicle Family
              </label>
              <input
                value={formData.vehicleFamily || ""}
                onChange={(e) => handleChange("vehicleFamily", e.target.value)}
                className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                placeholder="Vehicle Family"
              />
            </div>
          </div> */}
        </div>
      </div>

      <div className=" border-b  p-2">
        <div className="rounded-md">
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            className=""
            TabIndicatorProps={{
              className: "hidden ", // Hide default MUI indicator
            }}
          >
            <CustomTab
              label="Basic Information"
              icon={<FaInfoCircle className="text-blue-500" />}
            />
            <CustomTab
              label="Inventory & Structure Details"
              icon={<FaBoxes className="text-green-500" />}
            />
            <CustomTab
              label="Bill of Materials"
              icon={<FaClipboardList className="text-orange-500" />}
            />
            <CustomTab
              label="Packaging & Export Details"
              icon={<FaTruckLoading className="text-purple-500" />}
            />
            <CustomTab
              label="Specification & Barcode"
              icon={<FaBarcode className="text-gray-500" />}
            />
          </Tabs>
        </div>
      </div>

      <div className="">
        <div hidden={tabIndex !== 0}>
          <BasicInformation
            itemFromRequest={itemFromRequest}
            formData={formData}
            setFormData={setFormData}
            equivalentEntries={equivalentEntries}
            setEquivalentEntries={setEquivalentEntries}
            handleSaveEquivalent={handleSaveEquivalent}
            fetchImageAllow={fetchImageAllow}
            setFetchImageAllow={setFetchImageAllow}
            isEdit={isEdit}
            saveEquivalentPartTable={saveEquivalentPartTable}
            onEquivalentEntriesChange={handlePartTableEntriesChange}
          />
        </div>
        <div hidden={tabIndex !== 1}>
          <InventoryStructureDetails
            formData={formData}
            setFormData={setFormData}
            multiUnitsEntries={multiUnitsEntries}
            setMultiUnitsEntries={setMultiUnitsEntries}
            locationStockEntries={locationStockEntries}
            setLocationStockEntries={setLocationStockEntries}
            isEdit={isEdit}
          />
        </div>
        <div hidden={tabIndex !== 2}>
          <BillofMaterials
            ref={BOMRef}
            isEdit={isEdit}
            formData={formData}
            setFormData={setFormData}
            bomEntries={bomEntries}
            setBomEntries={setBomEntries}
            onBOMChange={(entries) =>
              setFormData((prev) => ({
                ...prev,
                bomEntries: entries,
              }))
            }
          />
        </div>
        <div hidden={tabIndex !== 3}>
          <PackagingExport formData={formData} setFormData={setFormData} />
        </div>
        <div hidden={tabIndex !== 4}>
          <SpecoficationBarcode formData={formData} setFormData={setFormData} />
        </div>
      </div>

      {/* Buttons */}
      {/* {canUserSeeThis("AE") ? ( */}
      <div className="flex justify-center space-x-3 pt-4">
        <Tooltip
          title={
            !formData.code
              ? "Please enter code"
              : isSaveDisabled
                ? "check for any missing Qty in BOM"
                : ""
          }
          arrow
        >
          <span>
            <button
              className={`px-4 py-2 rounded text-white 
    ${!formData.code || isSaveDisabled
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
                }`}
              onClick={save}
              disabled={!formData.code || isSaveDisabled}
            >
              {isEdit ? "Update Item" : "Save Item"}
            </button>
          </span>
        </Tooltip>

        <button
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          onClick={() => {
            setFormData(initialFormData);
            setIsEdit(false);
            BOMRef.current.resetBOM();
          }}
        >
          Clear
        </button>
      </div>
      {/* ) : (
        <div className="flex justify-center space-x-3 pt-4">
          <span className="text-red-500 font-semibold">
            You do not have access to create or edit items.
          </span>
        </div>
      )} */}

      {showCodeModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-80">
            <h3 className="text-lg font-semibold mb-3 text-gray-800">
              Code Already Exists
            </h3>

            <p className="text-sm text-gray-600 mb-5">
              The code <span className="font-semibold">{duplicateCode}</span>{" "}
              already exists. What would you like to do?
            </p>

            <div className="flex justify-between gap-3">
              <button
                onClick={handleCreateNewItem}
                className={`${canUserSeeThis("AE") ? "w-1/2" : "w-full"} py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700`}
              >
                Create New Item
              </button>

              {canUserSeeThis("AE") && (
                <button
                  onClick={() => handleEditExistingItem(duplicateCode)}
                  className="w-1/2 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white"
                >
                  Edit Item
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Auto-fill from Products Modal using F2 */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={"Select Product to Clone Content"}
        size="xxl"
        header={true}
      >
        <div className="product-modal-container">
          <ProductListing
            modalSuggestions={modalSuggestions}
            handleProductSelect={handleProductSelectFromModal}
            onSearchQueryChange={handleModalSearchQueryChange}
            loading={loadingModalData}
            setSearchBy={setSearchBy}
            searchBy={searchBy}
            pageNumber={modalPageNumber}
            pageSize={modalPageSize}
            totalRows={modalTotalRows}
            onPageChange={setModalPageNumber}
            searchQuery={modalSearchQuery}
            onRefresh={() =>
              fetchProductDataForModal(
                modalSearchQuery,
                searchBy,
                "A",
                modalPageNumber,
                modalPageSize,
              )
            }
          />
        </div>
      </Modal>
    </div>
  );
};

export default ItemCreation;
